export default {"src":"/_next/static/media/amsFavicon.447d589b.ico","height":65,"width":65,"blurWidth":0,"blurHeight":0};